import styled from 'styled-components'

export const SmallItalic = styled.span.attrs({ className: 'SmallItalic' })<{
  color?: string
}>`
  font-style: italic;
  font-size: 13px;
  letter-spacing: 0.2px;
  line-height: 1.3em;
  opacity: .6;
`
export const NormalBold = styled.span.attrs({ className: 'NormalBold' })<{
  color?: string
}>`
  font-size: 15px;
  letter-spacing: 0.2px;
  line-height: 1.4em;
  font-weight: 700;
  @media (max-width: 711px) {
  
  font-size: 13px;

}
`
export const NormalNormal = styled.span.attrs({ className: 'NormalBold' })<{
  color?: string
}>`
  font-size: 14px;
  letter-spacing: 0.2px;
  line-height: 1.3em;
  font-weight: 300;  
  
  @media (max-width: 711px) {
  
    font-size: 12px;

  }
`
